import { Button, CityState, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAgentQuickInfo extends Layout {
    buttonDrilldown: Button;
    citystateCSZ: CityState;
    panel1: Panel;
    sourceSettlementPayee: DataSource;
    textboxId: Textbox;
    textboxPhoneNumber: Textbox;
}
